import { render, staticRenderFns } from "./player-control.vue?vue&type=template&id=cfb60b5e&scoped=true&"
import script from "./player-control.vue?vue&type=script&lang=js&"
export * from "./player-control.vue?vue&type=script&lang=js&"
import style0 from "./player-control.vue?vue&type=style&index=0&id=cfb60b5e&prod&lang=scss&scoped=true&"
import style1 from "./player-control.vue?vue&type=style&index=1&id=cfb60b5e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfb60b5e",
  null
  
)

export default component.exports